import { AppointmentMisschedulingReasonOptions } from 'core/appointments/domain/Appointment'

export const APPOINTMENT_MISSCHEDULING_REASON_OPTIONS = [
  {
    value: AppointmentMisschedulingReasonOptions.FirstAvailable,
    label: 'First Available Appointment',
  },
  {
    value: AppointmentMisschedulingReasonOptions.InsufficientLeadTime,
    label: 'Insufficient Lead Time',
  },
  { value: AppointmentMisschedulingReasonOptions.WarehouseError, label: 'Warehouse Error' },
  { value: AppointmentMisschedulingReasonOptions.HolidayOrClosed, label: 'Holiday / Closed' },
  { value: AppointmentMisschedulingReasonOptions.PowerOutage, label: 'Power Outage' },
  { value: AppointmentMisschedulingReasonOptions.DelayedAtShipper, label: 'Delayed at Shipper' },
  { value: AppointmentMisschedulingReasonOptions.Reconsigned, label: 'Reconsigned' },
  { value: AppointmentMisschedulingReasonOptions.DeliveryRefused, label: 'Delivery Refused' },
  {
    value: AppointmentMisschedulingReasonOptions.DriverDelayedOnPreviousShipment,
    label: 'Driver Delayed on Previous Shipment',
  },
  {
    value: AppointmentMisschedulingReasonOptions.CapacityConstraints,
    label: 'Capacity Constraints',
  },
  {
    value: AppointmentMisschedulingReasonOptions.MechanicalBreakdown,
    label: 'Mechanical Breakdown',
  },
  {
    value: AppointmentMisschedulingReasonOptions.DropTrailerConstraints,
    label: 'Drop Trailer Constraints',
  },
  { value: AppointmentMisschedulingReasonOptions.MissedAppointment, label: 'Missed Appointment' },
  { value: AppointmentMisschedulingReasonOptions.Traffic, label: 'Traffic' },
  { value: AppointmentMisschedulingReasonOptions.DriverAccident, label: 'Driver Accident' },
  { value: AppointmentMisschedulingReasonOptions.DOTInspection, label: 'DOT Inspection' },
  { value: AppointmentMisschedulingReasonOptions.RailDelay, label: 'Rail Delay' },
  { value: AppointmentMisschedulingReasonOptions.DriverError, label: 'Driver Error' },
  {
    value: AppointmentMisschedulingReasonOptions.HoursOfServiceCompliance,
    label: 'Hours of Service Compliance',
  },
  { value: AppointmentMisschedulingReasonOptions.DispatcherError, label: 'Dispatcher Error' },
  { value: AppointmentMisschedulingReasonOptions.Weather, label: 'Weather' },
  { value: AppointmentMisschedulingReasonOptions.RoadClosure, label: 'Road Closure' },
  {
    value: AppointmentMisschedulingReasonOptions.Other,
    label: 'Other',
  },
]
